import {ActionReducerMapBuilder} from '@reduxjs/toolkit';

import {CPCState} from './slicer';
import {confirmCPCOTP, cpcGet, cpcList, preorderPlanCreate, preorderPlanGet} from './thunk';

export const cpcBuilder = (builder: ActionReducerMapBuilder<CPCState>) => {
  builder
    .addCase(preorderPlanGet.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(preorderPlanGet.fulfilled, (state: any, action: any) => {
      state.preorderCPC = action.payload.data;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(preorderPlanGet.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(preorderPlanCreate.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(preorderPlanCreate.fulfilled, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(preorderPlanCreate.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(confirmCPCOTP.pending, (state: any) => {
      state.confirmPaymentLoading = true;
    })
    .addCase(confirmCPCOTP.fulfilled, (state: any) => {
      state.confirmPaymentLoading = false;
    })
    .addCase(confirmCPCOTP.rejected, (state: any) => {
      state.confirmPaymentLoading = false;
    })
    .addCase(cpcList.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(cpcList.fulfilled, (state: any, action: any) => {
      const nextList = action.payload.data;
      if (
        nextList?.cpcs &&
        nextList.page > 1 &&
        state.cpcHistoryList?.cpcs?.length &&
        state.cpcHistoryList.page !== nextList.page
      ) {
        state.cpcHistoryList = {
          ...nextList,
          cpcs: [...state.cpcHistoryList.cpcs, ...nextList.cpcs]
        };
      } else {
        state.cpcHistoryList = nextList;
      }
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(cpcList.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(cpcGet.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(cpcGet.fulfilled, (state: any, action: any) => {
      state.cpcDetails = action.payload.data;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(cpcGet.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });
};
